let socket;

export const connectToWebSocket = (customerId, onMessageCallback) => {
  socket = new WebSocket(`ws://localhost:8081?customerId=${customerId}`);
  socket.onopen = () => {
    console.log(' WebSocket connected');
  };

  socket.onmessage = (message) => {
    try {
      const data = JSON.parse(message.data);
      console.log('📨 WebSocket message:', data);
      onMessageCallback?.(data);
    } catch (err) {
      console.error(' WebSocket message parse error:', err);
    }
  };

  socket.onclose = () => {
    console.log(' WebSocket closed');
  };

  socket.onerror = (err) => {
    console.error(' WebSocket error:', err);
  };
};

export const disconnectWebSocket = () => {
  if (socket) socket.close();
};
